/* src/app/dialogs/price-list-editor/price-list-editor.component.css */
/*# sourceMappingURL=price-list-editor.component-SEZ5NTP4.css.map */
